<template>
  <div class="card">
    <div class="card-header">
      <h4 class="title">Profile <small>(ID: {{userInfo.id}})</small></h4>
    </div>
    <div class="card-content">
      <form>
        <div class="row">
        
          <div class="col-md-6">

            <fg-input type="text"
                      disabled
                      label="Username"
                      placeholder="Username"
                      v-model="userInfo.username">
            </fg-input>
          </div>

          <div class="col-md-6">
              <label>Avatar:</label>
              <el-upload
                class="upload-demo"
                label="Avatar"
                ref="upload"
                :data="{user:userInfo.firstname+'_'+userInfo.lastname}"
                :on-success="handleAvatarSuccess"
                :show-file-list="false"
                :before-upload="beforeAvatarUpload"
                   :headers="headerInfo"
                :action="serverURL+'/storage/upload'"
                >
                <el-button slot="trigger" size="small" type="primary">select file</el-button>
          
                <div class="el-upload__tip" slot="tip">jpg/png files with a size less than 500kb</div>
              </el-upload>
            
          
          </div>

        </div>

        <div class="row">
          <div class="col-md-6">
            <fg-input type="text"
                      label="First Name"
                      placeholder="First Name"
                      v-model="userInfo.firstname">
            </fg-input>
          </div>
          <div class="col-md-6">
            <fg-input type="text"
                      label="Last Name"
                      placeholder="Last Name"
                      v-model="userInfo.lastname">
            </fg-input>
          </div>
        </div>

        <div class="row">
          <div class="col-md-6">
            <fg-input type="text"
                      label="Email address"
                      placeholder="Email address"
                      v-model="userInfo.email">
            </fg-input>
          </div>
          <div class="col-md-6">
            <fg-input type="text"
                      label="Role"
                      disabled
                      placeholder="Role"
                      v-model="userInfo.role">
            </fg-input>
          </div>
        </div>
    
        <div class="clearfix"></div>
      </form>
       <div class="row">
         <div class="card-header">
         <h4 class="title">Change Password</h4>

          <small>Your password was last changed {{userInfo.passwordUpdateDate | moment("from", "now")}} - {{userInfo.passwordUpdateDate | moment('DD/MM/YYYY H:mm:ss')}}</small>
         </div>
         <br />
          <div class="col-md-6">
         
            <el-form  :model="ruleForm" :rules="rules" ref="ruleForm" label-width="180px" class="demo-ruleForm">
              <el-form-item label="New Password" prop="password">
            <el-input v-model="ruleForm.password" autocomplete="off" clearable placeholder="Please input password"  show-password></el-input>
              </el-form-item>
              <el-form-item label="Confirm" prop="password2">
           <el-input v-model="ruleForm.password2" autocomplete="off"  clearable placeholder="Retype password"  show-password></el-input>
              </el-form-item>
           <button  class="btn btn-primary pull-right" @click="updatePassword('ruleForm')">
            Update Password
          </button> 
            </el-form>
          </div>
       
       </div>

    </div>
  </div>
</template>
<style>
  input[type=file]{
    display:none;
  }
</style>
<script>
import api from "../api";
import { USER_REQUEST,GET_USERS,GET_ROLE  } from '../../../store/actions/user'
import gql from "graphql-tag";
import moment from 'moment'
export default {
  props:['userInfo'],
  data () {
        var validatePass = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('Please input the password'));
        } else {
          if (this.ruleForm.password2 !== '') {
            this.$refs.ruleForm.validateField('checkPass');
          }
          callback();
        }
      };
      var validatePass2 = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('Please input the password again'));
        } else if (value !== this.ruleForm.password) {
          callback(new Error('Two inputs don\'t match!'));
        } else {
          callback();
        }
      };
    return {
    new_password:null,
    new_password2:null,
      serverURL: process.env.SERVER_URL,
      files:[],
      imageUrl: '',
      uploadData: {
        dataType: "0",
        oldFilePath:""
      },
       headerInfo: {
        'x-path': 'avatars/',
        'Authorization':'Bearer '+window.localStorage.getItem('jwt_token')
      },
      ruleForm: {
          password: '',
          password2: ''
        },
       rules: {
          password: [
            { validator: validatePass, trigger: 'blur' },
             { min: 8, max: 12, message: 'Length should be 8 to 12', trigger: 'blur' }
          ],
           password2: [
            { validator: validatePass2, trigger: 'blur' }
          ],
       }
    }
  },
  
  methods: {
    submitUpload() {
      this.$refs.upload.submit();
    },
    updateProfile () {
      alert('Your data: ' + JSON.stringify(this.userInfo))
    },
    updatePassword(formName){
      console.log('ok')
      this.$refs[formName].validate((valid) => {
          if (valid) {
 api.updatePassword({current_password:this.userInfo.password,password:this.ruleForm.password,id:this.userInfo.id,newDate:moment().add(1,'hours')}).then((result)=>{
    this.$store.dispatch(USER_REQUEST);
          this.$notify({
            title: "Password Updated",
            message: "Your password has been changed",
            type: "success"
          });
      })
          }else {
            console.log('error submit!!');
            return false;
          }
 })
},
    handleAvatarSuccess(res, file) {
      this.imageUrl = URL.createObjectURL(file.raw);
        const q = gql`
        mutation update_employee($id: Int, $avatar:String!) {
          update_Employee(where: { id: { _eq: $id } }, _set:  {avatar: $avatar}) {
            affected_rows
            returning {
              id
              
            }
          }
        }
      `;
        this.$apollo
        .mutate({
          mutation: q,
          variables: {
            id: this.userInfo.id,
           avatar:res[0]
          }
        })
        .then(result => {
       this.$store.dispatch(USER_REQUEST);
          this.$notify({
            title: "Updated",
            message: "Avatar Updated",
            type: "success"
          });
        })
        .catch(error => {
          this.$notify({
            title: "Error",
            message: error.message,
            type: "error"
          });
        });
    },
    beforeAvatarUpload(file) {
      console.log('before',file)
      const isJPG = file.type === 'image/jpeg' || file.type === 'image/png';
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isJPG) {
        this.$message.error('Avatar picture must be JPG or PNG format!');
      }
      if (!isLt2M) {
        this.$message.error('Avatar picture size can not exceed 2MB!');
      }
      return isJPG && isLt2M;
    }
  }
  
}
</script>
<style>
</style>s


// WEBPACK FOOTER //
// src/components/User/UserProfile/EditProfileForm.vue